module.exports = __webpack_public_path__ + "res/form_arrow_img.png";